import Vue from 'vue'
import BootstrapVue, { ToastPlugin, ModalPlugin } from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'

import i18n from '@/libs/i18n'
import router from './router'
import store from './store'
import App from './App.vue'

// Global Components
import './global-components'

// 3rd party plugins
import '@axios'
import '@/libs/acl'
import '@/libs/portal-vue'
import '@/libs/clipboard'
import '@/libs/toastification'
import '@/libs/sweet-alerts'
import '@/libs/vue-select'
import '@/libs/tour'

// devextrem css
import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.light.css';

// BSV Plugin Registration
Vue.use(BootstrapVue)
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)

// Composition API
Vue.use(VueCompositionAPI)

// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')

Vue.config.productionTip = false

// Attempt to silently restore session using the HTTP-only refresh cookie.
// The cookie is sent automatically because axiosIns has withCredentials: true.
// App mounts in .finally() so it always starts regardless of refresh outcome.
store.dispatch('auth/refreshToken')
  .catch((errorRefresh) => {
    const status = errorRefresh.response ? errorRefresh.response.status : null;
    if (status === 401 || status === 400) {
      localStorage.removeItem('userData')
    }
  })
  .finally(() => {
    new Vue({
      router,
      store,
      i18n,
      render: h => h(App),
    }).$mount('#app')
  })
